
export const urlWithContour = () => {
  const url = window.location.origin
  const demo = url.includes('demo.') ? 'demo.' : ''
  const contour =
      url.includes('dev.') ? 'dev.'
          :url.includes('stage.') ? 'stage.'
              : url.includes('localhost') ? 'enterprise.'
                  : url.includes('enterprise') ? 'enterprise.' :
                      url.includes('beta') ? 'beta.' : ''

  return 'https://' + contour + demo + 'lfqr.cc'
}
